var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	1679: {
		fallback: () => (() => (__webpack_require__(8254))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/link",

	},
	4198: {
		fallback: () => (__webpack_require__.e(6551).then(() => (() => (__webpack_require__(6551))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/dynamic",

	},
	7443: {
		fallback: () => (() => (__webpack_require__(2152))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/head",

	},
	5244: {
		fallback: () => (__webpack_require__.e(6593).then(() => (() => (__webpack_require__(4489))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	6467: {
		fallback: () => (__webpack_require__.e(6593).then(() => (() => (__webpack_require__(4349))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	6441: {
		fallback: () => (() => (__webpack_require__(9907))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/router",

	},
	4137: {
		fallback: () => (() => (__webpack_require__(4518))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "react-dom",

	},
	3596: {
		fallback: () => (__webpack_require__.e(6857).then(() => (() => (__webpack_require__(6857))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/script",

	},
	3114: {
		fallback: () => (__webpack_require__.e(8515).then(() => (() => (__webpack_require__(8515))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "next/image",

	},
	3676: {
		fallback: () => (__webpack_require__.e(5195).then(() => (() => (__webpack_require__(5195))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",

	},
	5065: {
		fallback: () => (__webpack_require__.e(3566).then(() => (() => (__webpack_require__(3566))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.6",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",

	},
	5233: {
		fallback: () => (() => (__webpack_require__(9971))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.5.2",
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "zustand",

	},
	4014: {
		fallback: () => (__webpack_require__.e(6593).then(() => (() => (__webpack_require__(2181))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",

	},
	1906: {
		fallback: () => (__webpack_require__.e(66).then(() => (() => (__webpack_require__(66))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-hook-form",

	},
	4685: {
		fallback: () => (__webpack_require__.e(8496).then(() => (() => (__webpack_require__(8496))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "@tanstack/react-query",

	},
	1623: {
		fallback: () => (__webpack_require__.e(537).then(() => (() => (__webpack_require__(537))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "axios",

	},
	218: {
		fallback: () => (__webpack_require__.e(1192).then(() => (() => (__webpack_require__(1192))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "zod",

	},
	6236: {
		fallback: () => (__webpack_require__.e(8807).then(() => (() => (__webpack_require__(8807))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-phone-number-input",

	},
	8275: {
		fallback: () => (() => (__webpack_require__(1888))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "next/compat/router",

	},
	7163: {
		fallback: () => (() => (__webpack_require__(8836))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "stores/use-breadcrumb-store",

	},
	5957: {
		fallback: () => (() => (__webpack_require__(8170))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "stores/use-toast-store",

	},
	9775: {
		fallback: () => (() => (__webpack_require__(5354))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "stores/use-user-store",

	},
	3691: {
		fallback: () => (__webpack_require__.e(1178).then(() => (() => (__webpack_require__(1178))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-lazily",

	},
	6036: {
		fallback: () => (__webpack_require__.e(6006).then(() => (() => (__webpack_require__(3625))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "@hookform/resolvers",

	},
	3707: {
		fallback: () => (() => (__webpack_require__(9393))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "stores/use-loading-store",

	},
	2949: {
		fallback: () => (__webpack_require__.e(5246).then(() => (() => (__webpack_require__(5246))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "react-i18next",

	},
	3867: {
		fallback: () => (() => (__webpack_require__(3083))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: "pages-dir-browser",
		shareKey: "stores/use-basket-store",

	},
	5315: {
		fallback: () => (__webpack_require__.e(1746).then(() => (() => (__webpack_require__(1746))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: "pages-dir-browser",
		shareKey: "dompurify",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [1679,4198,7443,5244,6467,6441,4137,3596,3114,3676,5065,5233,5244,6467,4014,4137,5233,4685,7443,1623,218,6236,8275,7163,5957,9775,3691,1906,6036,3707];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"636": [
		4685,
		7443,
		1623,
		218,
		6236,
		8275,
		7163,
		5957,
		9775
	],
	"1679": [
		1679
	],
	"1906": [
		1906
	],
	"3691": [
		3691
	],
	"4198": [
		4198
	],
	"4850": [
		5315
	],
	"5527": [
		7443,
		5244,
		6467,
		6441,
		4137,
		3596,
		3114,
		3676,
		5065,
		5233
	],
	"6036": [
		6036
	],
	"8136": [
		3707
	],
	"8792": [
		5244,
		6467,
		4014,
		4137,
		5233
	],
	"9776": [
		2949,
		3867
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}